export class ProfileDetail {
  title: string;
  details: Array<string>;
}

export class ProfileInfo {
  profileDetails: Array<ProfileDetail>;
  lastUpdated: Date;
}
